<template>
  <div>
    <div class="field has-addons" v-if="!engineer._id">
      <div class="control is-expanded">
        <input
          type="search"
          class="input"
          v-model="search"
          placeholder="Search Engineer"
          @keyup.enter="onSearchClicked"
        />
      </div>
      <div class="control">
        <button
          class="button is-primary"
          :class="{ 'is-loading': loading }"
          @click="onSearchClicked"
          :disabled="search.length < 3 || loading"
        >
          Search
        </button>
      </div>
    </div>
    <div class="card" v-if="engineer._id">
      <div class="card-content">
        <div class="is-flex">
          <table class="table is-fullwidth">
            <tr>
              <td>{{ engineer.employeeId }}</td>
              <td>{{ engineer.name }}</td>
              <td>{{ engineer.mobile }}</td>
              <td class="has-text-right">
                <a class="has-text-danger" @click="engineer = {}">Change</a>
              </td>
            </tr>
          </table>
        </div>
      </div>
    </div>
    <table class="table is-fullwidth is-hoverable" v-if="!engineer._id">
      <tbody>
        <tr
          v-for="record in docs"
          :key="record._id"
          :class="{ 'is-selected': record._id === engineer._id }"
          @click="onSelect(record)"
          style="cursor: pointer;"
        >
          <td>{{ record.employeeId }}</td>
          <td>{{ record.name }}</td>
          <td>{{ record.mobile }}</td>
        </tr>
        <tr v-show="engineer._id && docs.length === 0" class="is-selected">
          <td>{{ engineer.employeeId }}</td>
          <td>{{ engineer.name }}</td>
          <td>{{ engineer.mobile }}</td>
        </tr>
      </tbody>
    </table>
    <p class="has-text-centered has-text-grey" v-show="emptyMessageVisible">
      No results matching these criteria
    </p>
  </div>
</template>
<script>
export default {
  props: ["value"],
  data() {
    return {
      search: "",
      loading: false,
      engineer: {},
      emptyMessageVisible: false
    };
  },
  computed: {
    docs() {
      let component = this;
      return component.$store.getters["user/docs"];
    }
  },
  methods: {
    onSearchClicked() {
      let component = this;
      component.loading = true;
      component.emptyMessageVisible = false;
      component.engineer = {};
      component.$store.commit("user/search", component.search);
      component.$store
        .dispatch("user/index")
        .then(() => {
          component.loading = false;
          component.emptyMessageVisible = component.docs.length === 0;
        })
        .catch(error => {
          component.loading = false;
          console.log(error);
        });
    },
    onSelect(engineer) {
      let component = this;
      component.engineer = engineer;
      console.log(`Engineer: ${engineer.name}`);
      component.$emit("input", component.engineer);
    }
  },
  watch: {
    value() {
      let component = this;
      component.engineer = component.value;
    },
    search() {
      let component = this;
      component.emptyMessageVisible = false;
      component.$emit("input", {});
    }
  },
  mounted() {
    let component = this;
    component.$store.commit("user/page", 1);
    component.$store.commit("user/limit", 3);
    component.$store.commit("user/role", "engineer");
    component.$store.commit("user/docs", []);
  }
};
</script>
<style lang="scss" scopped>
.card {
  box-shadow: none;
  .card-content {
    padding: 0;
  }
}
</style>
